import { lazy, Suspense } from 'react';
import MaterialIcon from './MaterialIcon';

const HeroGlobe3D = lazy(() => import('./HeroGlobe3D'));

export default function Hero() {
  return (
    <section id="top" className="ca-hero" data-analytics-section="hero">
      <div className="ca-hero__grid" aria-hidden />
      <div className="ca-hero__glow ca-hero__glow--1" aria-hidden />
      <div className="ca-hero__glow ca-hero__glow--2" aria-hidden />

      <div className="ca-hero__content">
        <p className="ca-eyebrow ca-animate-in" style={{ animationDelay: '0.05s' }}>
          IT solutions &amp; custom software
        </p>
        <h1 className="ca-hero__title ca-animate-in" style={{ animationDelay: '0.15s' }}>
          Bold code.
          <br />
          <span className="ca-hero__title-accent">Brilliant trajectories.</span>
        </h1>
        <p className="ca-hero__lead ca-animate-in" style={{ animationDelay: '0.28s' }}>
          We bridge vision and reality—scalable platforms, human-centric design, and software that
          turns friction into flow for teams ready to lead.
        </p>
        <div className="ca-hero__actions ca-animate-in" style={{ animationDelay: '0.4s' }}>
          <a href="#contact" className="ca-btn ca-btn--primary">
            <MaterialIcon name="mail" variant="none" className="ca-btn__icon" />
            Talk to us
          </a>
          <a href="#services" className="ca-btn ca-btn--outline">
            <MaterialIcon name="explore" variant="none" className="ca-btn__icon" />
            Explore services
          </a>
        </div>
      </div>

      <div className="ca-hero__visual ca-animate-in" style={{ animationDelay: '0.35s' }} aria-hidden>
        <div className="ca-hero__orbit">
          <div className="ca-hero__arc-scene">
            <svg className="ca-arc-svg" viewBox="0 0 560 380" fill="none" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <linearGradient id="arcGrad" x1="0%" y1="50%" x2="100%" y2="50%">
                  <stop offset="0%" stopColor="#7f1d1d" stopOpacity="0.35" />
                  <stop offset="42%" stopColor="#dc2626" stopOpacity="1" />
                  <stop offset="100%" stopColor="#fecaca" stopOpacity="0.65" />
                </linearGradient>
                <filter id="arcGlow" x="-30%" y="-30%" width="160%" height="160%">
                  <feGaussianBlur stdDeviation="10" result="blur" />
                  <feMerge>
                    <feMergeNode in="blur" />
                    <feMergeNode in="SourceGraphic" />
                  </feMerge>
                </filter>
              </defs>
              <path
                className="ca-arc-svg__path"
                pathLength={100}
                fill="none"
                d="M 28 308 Q 280 8 532 308"
                stroke="url(#arcGrad)"
                strokeWidth="4"
                strokeLinecap="round"
                filter="url(#arcGlow)"
              />
              <circle className="ca-arc-svg__node ca-arc-svg__node--a" cx="28" cy="308" r="7" fill="#ef4444" />
              <circle className="ca-arc-svg__node ca-arc-svg__node--b" cx="532" cy="308" r="7" fill="#fecaca" />
              <path
                className="ca-arc-svg__spark"
                pathLength={100}
                d="M 100 268 L 168 198 L 248 242 L 312 158 L 400 208 L 488 128"
                stroke="rgba(248,113,113,0.45)"
                strokeWidth="1.75"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
              />
            </svg>
          </div>
          <div className="ca-globe-stage">
            <Suspense fallback={<div className="ca-globe-canvas ca-globe-canvas--skeleton" aria-hidden />}>
              <HeroGlobe3D />
            </Suspense>
          </div>
        </div>
        <div className="ca-hero__stats">
          <div className="ca-stat">
            <MaterialIcon name="account_tree" variant="drift" className="ca-stat__icon" />
            <span className="ca-stat__label">Design → build → scale</span>
          </div>
          <div className="ca-stat">
            <MaterialIcon name="cloud" variant="float" className="ca-stat__icon" />
            <span className="ca-stat__label">Cloud-native mindset</span>
          </div>
        </div>
      </div>
    </section>
  );
}
